import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss']
})
export class LoadingAnimationComponent {
  @Input() height: string = "1.4rem";
  @Input() color: string = "#001f54";

  constructor() {
    
  }
}
